import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "cap-body" }
const _hoisted_2 = { class: "popup-body" }
const _hoisted_3 = { class: "popup-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxScrolling = _resolveComponent("DxScrolling")!
  const _component_DxPopup = _resolveComponent("DxPopup")!
  const _component_DxItem = _resolveComponent("DxItem")!
  const _component_DxFormPopup = _resolveComponent("DxFormPopup")!
  const _component_DxEditing = _resolveComponent("DxEditing")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxLookup = _resolveComponent("DxLookup")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!
  const _component_DxSelectionGrid = _resolveComponent("DxSelectionGrid")!
  const _component_DxSearchPanel = _resolveComponent("DxSearchPanel")!
  const _component_DxButton = _resolveComponent("DxButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_DxDataGrid, {
      "data-source": _ctx.ds,
      ref: "gridRef",
      "key-expr": "Id",
      "show-borders": true,
      height: "100%",
      "row-alternation-enabled": true,
      "hover-state-enabled": true,
      "no-data-text": "Nu există componente de sumă pentru angajatul selectat.",
      onContextMenuPreparing: _ctx.onContextMenu
    }, {
      default: _withCtx(() => [
        _createVNode(_component_DxScrolling, { mode: "virtual" }),
        _createVNode(_component_DxEditing, {
          "allow-updating": true,
          "allow-deleting": true,
          "allow-adding": true,
          mode: "popup"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_DxPopup, {
              "show-title": true,
              title: "Componentă sumă",
              width: 540,
              height: 400
            }),
            _createVNode(_component_DxFormPopup, { "col-count": 1 }, {
              default: _withCtx(() => [
                _createVNode(_component_DxItem, { "data-field": "Ordine" }),
                _createVNode(_component_DxItem, { "data-field": "SemnOperatie" }),
                _createVNode(_component_DxItem, { "data-field": "CodVariabilaSalarii" }),
                _createVNode(_component_DxItem, { "data-field": "ContId" }),
                _createVNode(_component_DxItem, { "data-field": "Activa" })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Ordine",
          caption: "Ordine",
          width: 80,
          alignment: "center"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "SemnOperatie",
          caption: "Semn",
          width: 80,
          alignment: "center"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "CodVariabilaSalarii",
          caption: "Cod variabilă salarii",
          "min-width": 180
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "ContId",
          caption: "Cont contabil",
          "min-width": 180
        }, {
          default: _withCtx(() => [
            _createVNode(_component_DxLookup, {
              "data-source": _ctx.dsConturi,
              "value-expr": "Id",
              "display-expr": _ctx.contDisplay,
              "search-enabled": true
            }, null, 8, ["data-source", "display-expr"])
          ]),
          _: 1
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Activa",
          caption: "Activă",
          "data-type": "boolean",
          width: 80
        })
      ]),
      _: 1
    }, 8, ["data-source", "onContextMenuPreparing"]),
    _createVNode(_component_DxPopup, {
      visible: _ctx.popupVisible,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.popupVisible) = $event)),
      title: "Copiază formulele către angajați specificați",
      width: 480,
      height: 520,
      "show-close-button": true,
      "drag-enabled": true
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_DxDataGrid, {
            "data-source": _ctx.angajati,
            "key-expr": "Id",
            height: "420",
            "show-borders": true,
            "hover-state-enabled": true,
            onSelectionChanged: _ctx.onSelectionChanged,
            "selected-row-keys": _ctx.selectedKeys
          }, {
            default: _withCtx(() => [
              _createVNode(_component_DxSelectionGrid, {
                mode: "multiple",
                "show-check-boxes-mode": "always"
              }),
              _createVNode(_component_DxScrolling, { mode: "virtual" }),
              _createVNode(_component_DxSearchPanel, {
                visible: true,
                placeholder: "Caută angajat…"
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "InternalCode",
                caption: "Marca",
                width: 70
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "NumePrenume",
                caption: "Nume"
              })
            ]),
            _: 1
          }, 8, ["data-source", "onSelectionChanged", "selected-row-keys"]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_DxButton, {
              text: "Anulează",
              "styling-mode": "outlined",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.popupVisible = false))
            }),
            _createVNode(_component_DxButton, {
              text: "Copiază",
              type: "default",
              "styling-mode": "contained",
              onClick: _ctx.confirmCopiere,
              disabled: !_ctx.selectedKeys.length
            }, null, 8, ["onClick", "disabled"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}